/* eslint-disable max-lines-per-function */
import { useDeleteSchichtVerknuepfung } from '@/domain/termine/hooks/useDeleteSchichtVerknuepfung';
import { useToast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import { Button } from '@e2n/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkLarge } from '@fortawesome/pro-regular-svg-icons';
import { Schichten } from '@/domain/termine/shared/types/Schichten';
import { SchichtInfo } from '@/domain/termine/features/UpdateTermin/shared/Verknuepfungen/SchichtVerknuepfung/SchichtVerknuepfungInfo';
import { MitarbeiterSchichtenPopover } from '@/domain/termine/features/Calendar/shared/TerminInfo/Verknuepfungen/MitarbeiterSchichtenPopover';

export function SchichtVerknuepfungCard({
  schichten,
  terminId,
}: {
  schichten: Schichten;
  terminId?: string;
}) {
  const { deleteSchichtVerknuepfung, loading } = useDeleteSchichtVerknuepfung();
  const { toast } = useToast();
  const { t } = useTranslation();

  async function handleDelete() {
    if (!terminId) {
      Sentry.captureMessage(
        'Fehlende terminId für Schicht-Verknüpfung entfernen',
        {
          level: 'warning',
          extra: {
            terminId,
            schichtId: schichten.id,
          },
        },
      );
      toast({
        title: t('domain.termine.verknuepfung.deleteError'),
      });
      return;
    }
    try {
      const result = await deleteSchichtVerknuepfung({
        idTerminDefinition: terminId,
        idSchichten: schichten.id,
      });
      if (result?.result && result.result.idSchichten) {
        toast({ title: t('domain.termine.verknuepfung.deleteSuccess') });
      } else {
        toast({
          title: t('domain.termine.verknuepfung.deleteError'),
          description: result?.error?.message,
        });
      }
    } catch (err) {
      Sentry.captureException(err);
      toast({
        title: t('domain.termine.verknuepfung.deleteError'),
        description: err instanceof Error ? err.message : String(err),
      });
    }
  }

  return (
    <div className="flex gap-2 items-center justify-between w-full p-3 border border-neutrals-300 rounded-lg">
      <SchichtInfo schicht={schichten} />
      <MitarbeiterSchichtenPopover mitarbeiterListe={schichten.mitarbeiter} />
      <Button
        type="button"
        aria-label={t('domain.termine.form.verknuepfungEntfernen')}
        title={t('domain.termine.form.verknuepfungEntfernen')}
        variant="ghost"
        size="icon"
        disabled={loading}
        onClick={handleDelete}>
        <FontAwesomeIcon icon={faXmarkLarge} />
      </Button>
    </div>
  );
}
